require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./es-mx-update-aidesep-progresa-a-pasos-agigantados-hacia-la-titulacion.json") })
        }
      }, "path---es-mx-update-aidesep-progresa-a-pasos-agigantados-hacia-la-titulacion");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---es-mx-update-aidesep-progresa-a-pasos-agigantados-hacia-la-titulacion!./.cache/json/es-mx-update-aidesep-progresa-a-pasos-agigantados-hacia-la-titulacion.json
// module id = 914
// module chunks = 231608221292675